module.exports = __webpack_public_path__ + "static/img/sstop_cn.842462e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/sstop_cn.png
// module id = EJhm
// module chunks = 0